var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1085_924",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6259 0H0V17H16.6259V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1085_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89468 7.19464L16.0841 0H14.6174L9.24314 6.24701L4.95076 0H0L6.49093 9.44658L0 16.9913H1.46677L7.14209 10.3942L11.6752 16.9913H16.6259L9.89432 7.19464H9.89468ZM7.88574 9.52981L7.22808 8.58914L1.99526 1.10416H4.24813L8.47107 7.14478L9.12874 8.08545L14.6181 15.9373H12.3652L7.88574 9.53017V9.52981Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitterLogo.d1c21ae2f3b78afb0586b1e650e855b2.svg";
export { ForwardRef as ReactComponent };